import PropTypes from 'prop-types';
import React, { useState } from 'react';
import fr from 'facet-rest';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import {
  FDBox, FDHorizontalTabs, FDVerticalTabs, FDTabPanel, FDStack,
} from '@facet-wealth/design';

const TabComponentMap = {
  horizontal: FDHorizontalTabs,
  vertical: FDVerticalTabs,
};

const TabGroup = ({
  resource,
  layouts,
  selectedTab,
  direction,
  tabAlignment,
}) => {
  const tabLinks = resource.relationships().list().filter(link => link.meta('type') === relationshipType.tabLink);
  let TabComponent = TabComponentMap[direction];

  if (!TabComponent) {
    TabComponent = FDHorizontalTabs;
  }
  const TAB_OPTIONS = [];
  for (const tabLink of tabLinks) {
    if (layouts[tabLink.attr('name')]) {
      TAB_OPTIONS.push({
        label: tabLink.meta('prompt'),
        value: tabLink.attr('name'),
      });
    }
  }

  let initialTab = TAB_OPTIONS[0].value;
  // only set the initial tab to selectedTab if it is a valid tab
  if (selectedTab && TAB_OPTIONS.map(option => option.value).includes(selectedTab)) {
    initialTab = selectedTab;
  }

  const [tab, setTab] = useState(initialTab);

  return (
    <FDStack direction={direction === 'vertical' ? 'row' : 'column'} alignItems={tabAlignment} paddingY={4} spacing={4}>
      <TabComponent
        onChange={(event, v) => { setTab(v); }}
        value={tab}
        options={TAB_OPTIONS}
      />
      <FDBox width={'100%'}>
        {TAB_OPTIONS.map((tabOption) => (
          <FDTabPanel
            id={tabOption.value}
            value={tab}
            key={tabOption.value}
          >
            {layouts[tabOption.value]}
          </FDTabPanel>
        ))}
      </FDBox>
    </FDStack>
  );
};

TabGroup.defaultProps = {
  selectedTab: null,
  direction: 'horizontal',
  tabAlignment: 'center',
};

TabGroup.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  layouts: PropTypes.object.isRequired,
  selectedTab: PropTypes.string,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  tabAlignment: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
};

export default TabGroup;
